import React, { useState } from 'react';
import BaseImage from './base-image';
import {
  FiChevronDown,
  FiChevronUp,
  FiPlus,
  FiTrash,
  FiTrash2,
} from 'react-icons/fi';
import AppButton from './button';

interface CollapsibleProps {
  entityType?: string;
  label?: string;
  isOpen: boolean;
  index: number;
  toggle?: () => void;
  remove?: () => void;
  loadingRemove?: boolean;
  addMore?: () => void;
  proceed?: () => void;
  proceedText?: string;
  disableProceed?: boolean;
  loadingProceed?: boolean;
  children?: React.ReactElement;
}

const BaseCollapsible: React.FC<CollapsibleProps> = ({
  entityType = 'Entry',
  label,
  isOpen,
  index,
  toggle,
  remove,
  loadingRemove,
  addMore,
  proceed,
  proceedText,
  disableProceed,
  loadingProceed,
  children,
}) => {
  return (
    <div className={`border px-8 py-[0.8rem] rounded-xl`} key={index}>
      <div
        className="flex items-center justify-between cursor-pointer text-sm"
        onClick={toggle}
      >
        {label ? (
          <p>{label}</p>
        ) : (
          <p>
            {entityType} {index + 1}
          </p>
        )}
        {isOpen ? <FiChevronUp /> : <FiChevronDown />}
      </div>

      {isOpen && (
        <div>
          <div className="my-12">{children}</div>
          {/* Collapsible Footer */}
          <div className="flex items-center gap-6 justify-end">
            {addMore && (
              <AppButton
                type="gray"
                label="Add more"
                icon={<FiPlus />}
                clicked={addMore}
                fullWidth={false}
                size="md"
              />
            )}
            {remove && (
              <AppButton
                type="danger"
                label="Delete"
                icon={<FiTrash2 />}
                clicked={remove}
                fullWidth={false}
                size="md"
                loading={loadingRemove}
              />
            )}
            {proceed && (
              <AppButton
                type="dark"
                label={proceedText ?? 'Proceed'}
                clicked={proceed}
                fullWidth={false}
                size="md"
                extraClass="!px-12"
                disabled={disableProceed}
                loading={loadingProceed}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BaseCollapsible;
